import "./ListTable.css";
import { Table, Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import dayjs from "dayjs";

export default function ListTable(props) {
  // reusable table displaying a list of items
  //props:
  //    dataArray: array of json objects
  //    headers: array of Strings, used to build the table headers
  //      ...for date fields, header should be "Date" or won't be formatted
  //    fieldNames: names of the json object attributes to be displayed
  //      ...for nested fields, pass the field in like this: ["fieldName","nestedFieldName"]
  //    view: String with link (if provided, view button will be visible)
  //    edit: String with link (if provided, view button will be visible)
  //    delete: function, if provided, delete button will be visible

  const checkmark = <i className="bi bi-check-lg text-success"></i>;
  const xSymbol = <i className="bi bi-x-lg text-danger"></i>;

  const formatDate = (date) => date && dayjs(date).format("MMM DD, YYYY");

  const formatCurrency = (amount) => {
    const roundedAmount = Number(amount).toFixed(2);
    return "$" + roundedAmount.toLocaleString("en-CA", {
      style: "currency",
      currency: "CAD",
    });
  };

  const refundedElement = <span style={{fontSize: "small", fontStyle: "italic", color: "#dc3545"}}>refunded</span> 

  const returnedElement = <span style={{fontSize: "small", fontStyle: "italic", color: "#dc3545"}}>returned</span> 

  const generateContent = (rowData, field, header) => {
    // boolean
    if (rowData[field] === true) {
      if(header === "Paid"){
        return rowData?.refunded ? refundedElement: checkmark;
      } else if(header === "Delivered"){
        return rowData?.returned ? returnedElement : checkmark; 
      }
      return checkmark;
    } else if (rowData[field] === false) {
      return xSymbol; 
      // arrays
    } else if (Array.isArray(field)) {
      if (header === "Date") {
        return formatDate(rowData[field[0]]?.[field[1]]); // array with date header
      }
        else if(header === "Total") { // currency 
          return rowData[field[0]]?.[field[1]] &&
          formatCurrency(rowData[field[0]][field[1]])
        }
       else {
        return rowData[field[0]]?.[field[1]]; // other array
      }
    } else {
      // simple field (date, price, other)
      return header === "Date"
        ? formatDate(rowData[field]) // date
        : header === "Price" // currency
        ? formatCurrency(rowData[field])
        : rowData[field]; // other
    }
  };
   
  
  return (
    <Table
      className="mt-4"
      rounded="md"
      hover
      responsive
      style={{ borderLeft: "none", borderRight: "none" }}
    >
      <thead>
        <tr>
          <th>#</th>
          {props?.headers.map((header, idx) => {
            return <th key={idx}>{header}</th>;
          })}
          <th></th>
        </tr>
      </thead>
      <tbody>
        {!props.dataArray || props.dataArray.length < 1 ? (
          <tr className="mt-2">
            <td>No data available to show.</td>
          </tr>
        ) : (
         Array.isArray(props?.dataArray) && props.dataArray.map((rowData, idx) => {
            return (
              <tr key={idx} className="list-table-tr">
                <td className="list-table-td">{idx + 1}</td>
                {/* if boolean, show checkmark/x symbol, else show field value */}
                {props?.fieldNames.map((field, idx) => {
                  
                  return (
                    <td key={idx} className="list-table-td">
                      {/* check if boolean, array, date, price */}
                      {generateContent(rowData, field, props.headers[idx])}
                    </td>
                  );
                })}
                <td className="d-flex justify-content-end list-table-td">
                  {/* show buttons */}
                  {props.edit ? (
                    <>
                      <LinkContainer to={props.edit + `/${rowData._id}`}>
                        <Button className="btn-sm" variant="warning">
                          <i className="bi bi-pencil-square"></i>
                        </Button>
                      </LinkContainer>
                      {"\u00A0\u00A0\u00A0"}
                    </>
                  ) : null}
                  {props.delete ? (
                    <>
                      <Button
                        className="btn-sm "
                        variant="danger"
                        disabled={rowData?.doNotDelete}
                        onClick={() => props.delete(rowData._id)}
                      >
                        <i className="bi bi-trash3-fill"></i>
                      </Button>{" "}
                      {"\u00A0\u00A0\u00A0"}
                    </>
                  ) : null}
                  {props.view ? (
                    <>
                      <LinkContainer to={props.view + `/${rowData._id}`}>
                        <Button className="btn-sm mt-1 " variant="light">
                          View
                        </Button>
                      </LinkContainer>
                    </>
                  ) : null}
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </Table>
  );
}
